'use client';

import Script from 'next/script';
import { useGoogleAnalytics } from '@/lib/analytics';
import { useConsent } from '@/lib/consent';

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export default function GoogleAnalytics() {
  useGoogleAnalytics();
  const consent = useConsent();

  // Nothing from Google loads until the visitor accepts cookies (PECR).
  if (!GA_MEASUREMENT_ID || consent !== 'granted') return null;

  return (
    <>
      <Script data-component-id="src/components/GoogleAnalytics.tsx:18:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="18" data-component-end-line="21" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%7D"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script data-component-id="src/components/GoogleAnalytics.tsx:22:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="22" data-component-end-line="58" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-analytics%22%7D" id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          // Headless-automation guard.
          //
          // This property carried 1,043 Direct sessions in the 90 days to
          // 2026-09-29 at 12% engagement, 10 seconds and 1.1 pages per session.
          // 361 came from Singapore at 2% engaged and 69 from Ashburn at 0%:
          // AWS and GCP regions, not customers. That was 80% of all recorded
          // traffic, against 130 Organic sessions that behave like people
          // (71 seconds, 1.9 pages, 57% engaged).
          //
          // Every engagement rate, channel comparison and conversion rate read
          // off this property has been wrong by roughly 5x because of it.
          //
          // navigator.webdriver is set by Chrome, Firefox and Safari whenever
          // the browser is driven by WebDriver, which is how most of this
          // arrives. It will not catch everything, and it does not replace
          // reading Organic rather than Direct, but it costs nothing.
          if (!navigator.webdriver) {
            // Loaded only after Accept. Measurement is allowed; ad personalisation
            // (remarketing) is not used, so it stays denied.
            gtag('consent', 'default', {
              analytics_storage: 'granted',
              ad_storage: 'granted',
              ad_user_data: 'granted',
              ad_personalization: 'denied'
            });
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}', {
              page_path: window.location.pathname,
              send_page_view: true
            });
          }
        `}
      </Script>
    </>
  );
}
